import { Info } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

/**
 * Small (i) icon that explains a setting on hover / keyboard focus.
 * `what` = plain-English meaning, `effect` = what changing it does.
 */
export default function InfoTip({ title, what, effect, testid }) {
  return (
    <TooltipProvider delayDuration={120}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" aria-label={`About ${title}`} data-testid={testid}
            className="inline-flex items-center justify-center w-4 h-4 ml-1 align-middle text-kl-mutedLight hover:text-kl-black focus-visible:text-kl-black focus-visible:outline focus-visible:outline-1 focus-visible:outline-kl-green transition-colors duration-150">
            <Info size={14} strokeWidth={2} />
          </button>
        </TooltipTrigger>
        <TooltipContent side="right" align="start" sideOffset={10}
          className="w-72 rounded-none border border-kl-line bg-kl-black p-0 text-white shadow-xl">
          <div className="border-b border-kl-line px-4 py-2.5 font-display text-sm">{title}</div>
          <div className="space-y-2.5 px-4 py-3 text-[12px] leading-relaxed text-white/80">
            <p>{what}</p>
            {effect && <p><span className="block kl-label-dark mb-0.5">If you change it</span>{effect}</p>}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
